module.exports = __webpack_public_path__ + "img/img34.b69c5a99.png";